import L from "leaflet";

import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.css";
import "../styles/controls.css";

import "../extensions/L.Control.MapCenterCoord.min.js";
import "../extensions/L.Control.MapCenterCoord.min.css";
import "../extensions/leaflet.scalefactor";
import "../extensions/leaflet.scalefactor.css";

import store from "@/store";
import { eventBus } from "@/main";

// Класс для управления картой Leaflet с канвасом
export class MyLeafCanvas {
  lastZoom = 0;

  init(el, url, center, zoom, minZoom = 2, maxZoom = 20, options = {}) {
    // Проверяем, не инициализирована ли уже карта в этом элементе
    if (el._leaflet_id) {
      console.warn(
        "Map container is already initialized, skipping re-initialization"
      );
      return;
    }

    let southWest = L.latLng(-85, -540.0),
      northEast = L.latLng(85, 540.0),
      mybounds = L.latLngBounds(southWest, northEast);

    this.map = new L.map(el, {
      zoomControl: false,
      preferCanvas: true,
      scrollWheelZoom: "center",
      maxBounds: mybounds,
      ...options,
    }).setView(center, zoom);

    L.control
      .mapCenterCoord({ position: "bottomright", latlngFormat: "DD" })
      .addTo(this.map);
    L.control.scalefactor({ position: "bottomright" }).addTo(this.map);

    this.currentMapsURL = url;

    L.control
      .mapCenterCoord({ latlngFormat: "DM", latlngDesignators: true })
      .addTo(this.map);

    this.mainLayer = L.tileLayer(this.currentMapsURL, {
      // zoomControl: false,
      minZoom: minZoom,
      maxZoom: maxZoom,
      maxBounds: mybounds,
      attribution:
        "\"Map data &copy; <a href='http://probki.net/b2b'>Geophone OY</a>",
      ...options,
    }).addTo(this.map);

    L.control
      .zoom({
        position: "bottomright",
      })
      .addTo(this.map);

    let leafletItems = document.getElementsByClassName(
      "leaflet-control-attribution"
    );
    leafletItems.forEach((item) => {
      item.style.display = "none";
    });

    this.map.on("moveend", () => {});

    this.map.on("zoomend", () => {
      this.controlTooltips();
    });

    this.map.on("drag", () => {
      eventBus.$emit("map-drag");
    });

    this.map.on("dragend", (event) => {
      let coordinates = this.map.getCenter();
      let offset = 0;
      while (coordinates.lng >= 180) {
        coordinates.lng -= 360;
        offset -= 360;
      }

      while (coordinates.lng < -180) {
        coordinates.lng += 360;
        offset += 360;
      }
      eventBus.$emit("map-drag-offset", offset);

      this.map.setView(coordinates, this.map.getZoom(), { animate: false });
    });

    this.map.setMaxBounds(mybounds);
    return this.map;
  }

  // Инициализация тултипов на карте
  initTooltips() {
    let zoom = this.map.getZoom();
    let tooltipThreshold = 10;
    if (zoom < tooltipThreshold) {
      this.map.eachLayer((l) => {
        if (l.getTooltip) {
          let toolTip = l.getTooltip();
          if (toolTip && toolTip._content) {
            if (toolTip._content.startsWith("WP")) {
              l.unbindTooltip().bindTooltip(toolTip, {
                permanent: false,
              });
            }
          }
        }
      });
    } else if (zoom >= tooltipThreshold) {
      this.map.eachLayer((l) => {
        if (l.getTooltip) {
          let toolTip = l.getTooltip();
          if (toolTip && toolTip._content) {
            if (toolTip._content.startsWith("WP")) {
              l.unbindTooltip().bindTooltip(toolTip, {
                permanent: true,
              });
            }
          }
        }
      });
    }
    this.lastZoom = zoom;
  }

  // Управление тултипами в зависимости от зума
  controlTooltips() {
    let zoom = this.map.getZoom();

    let tooltipThreshold = 12;
    if (
      zoom < tooltipThreshold &&
      (!this.lastZoom || this.lastZoom >= tooltipThreshold)
    ) {
      this.map.eachLayer((l) => {
        if (l.getTooltip) {
          let toolTip = l.getTooltip();
          if (toolTip && toolTip._content) {
            if (toolTip._content.startsWith("WP")) {
              l.unbindTooltip().bindTooltip(toolTip, {
                permanent: false,
              });
            }
          }
        }
      });
    } else if (
      zoom >= tooltipThreshold &&
      (!this.lastZoom || this.lastZoom < tooltipThreshold)
    ) {
      this.map.eachLayer((l) => {
        if (l.getTooltip) {
          let toolTip = l.getTooltip();
          if (toolTip && toolTip._content) {
            if (toolTip._content.startsWith("WP")) {
              l.unbindTooltip().bindTooltip(toolTip, {
                permanent: true,
              });
            }
          }
        }
      });
    }
    this.lastZoom = zoom;
  }

  moveTo(lat, lon) {
    this.map.setView([lat, lon]);
  }

  panToZone(bounds) {
    this.map.fitBounds(bounds);
  }

  redrawMap(URL, coordinates, zoom_level) {
    this.mainLayer.remove();
    this.map.setView(coordinates, zoom_level);
    this.mainLayer = L.tileLayer(URL);
    this.mainLayer.addTo(this.map);
  }

  // Базовый метод для очистки карты
  destroy() {
    try {
      if (this.map) {
        // Удаляем основной слой
        if (this.mainLayer) {
          this.mainLayer.remove();
          this.mainLayer = null;
        }

        // Удаляем карту
        this.map.remove();
        this.map = null;

        console.log("MyLeafCanvas: карта очищена");
      }
    } catch (error) {
      console.warn("MyLeafCanvas: ошибка при очистке карты", error);
    }
  }
}
